import React, { memo } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import styles from './styles.module.scss';




const Index = memo((props) => {

  const dispatch = useDispatch();
  const { handleNewsDetail } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const localesReducer = useSelector(({localesReducer}) => localesReducer.i18n);
  const { value: scrollNumReducer, cshVal } = useSelector(({scrollNumReducer}) => scrollNumReducer);

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return styles.normalSm;
    }
  };

  const { bgImg, svgTitle, title, innerContentStyles, otherStyle } = props.config;
  return (
      <div className={normal()}>
          <div
              className="innerContent"
              style={{
                background: `url(${bgImg}) no-repeat 100% 100%/cover`,
                ...innerContentStyles,
              }}
          >
            <div className="title" style={otherStyle.svgTitleCss}>
              <img style={otherStyle.svgTitleCss} src={svgTitle} alt=""/>
            </div>
            <div className="subTitle"><span data-langkey="MTMPOT100" style={otherStyle.subTitleStyle ? otherStyle.subTitleStyle : null}>{title}</span></div>
          </div>
      </div>
  );
});
export default Index;
